import { render } from "./MaterialLibrary.vue?vue&type=template&id=61e55031&scoped=true"
import script from "./MaterialLibrary.vue?vue&type=script&lang=js"
export * from "./MaterialLibrary.vue?vue&type=script&lang=js"

import "./MaterialLibrary.vue?vue&type=style&index=0&id=61e55031&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e55031"]])

export default __exports__